import { XMarkIcon } from '@heroicons/react/24/outline'
import Axios from 'axios'
import { useState, useEffect } from 'react'
import Pagination from '../components-contabilidad-analisis/Pagination'
import WarningModal from "../components-modals/WarningModal"
import ResultadosAlumnos from './ResultadosAlumnos'
import Cookies from "universal-cookie"
import { Field, Form, Formik } from 'formik'

const campos = [
    { name: 'Alumno', type: 'text', position: '' },
    { name: 'Cel', type: 'number', position: '' },
    { name: 'Email', type: 'email', position: 'order-last col-span-full' },
    { name: 'Nit', type: 'text', position: '' },
    { name: 'Carnet', type: 'text', position: '' }
]

const BusquedaAlumnosModal = ({ showForm, setShowForm, url, headers, setModal, setFieldValue, values }) => {

    const cookies = new Cookies()
    const urlInvoiceApi = cookies.get('__urlInvoiceApi')
    const urlNit = urlInvoiceApi + '/utils/cliente'

    
    
    const [alumnos, setAlumnos] = useState([])
    const fetchData = async (params, resetForm) => {
        try {
            const { data } = await Axios({
                method: 'GET',
                url,
                headers,
                params
            })

            setAlumnos(data.msg)


        } catch (err) {
            resetForm()
            setModal({
                show: true,
                ok: false,
                msg: 'Sin resultados, intente de nuevo.'
            })
            console.log(err)
        }
    }

    //Paginación Productos
    const [currentPage, setCurrentPage] = useState(1)
    const recordsPerPage = 5

    const indexOfLastRecord = currentPage * recordsPerPage
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage

    const currentRecords = alumnos?.slice(indexOfFirstRecord, indexOfLastRecord)

    const nPages = Math.ceil(alumnos?.length / recordsPerPage)
    //Fin paginación Productos

    const isNumber = (x) => {
        const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
        return numbers.some(y => y === Number(x))
    }

    const handleChange = (e, flag, resetForm, setInnerFieldValue) => {
        setInnerFieldValue(flag, e.target.value);

        if (!e.target.value || e.target.value.length < 4) {
            return;
        }

        const params = {
            "opcion": "ALUMNOS",
        }
        
        if (flag === 'Carnet' && e.target.value.length > 12){

            setInnerFieldValue(flag, e.target.value.slice(0, -1));
            params[flag] = e.target.value.trim().slice(0, -1)
            fetchData(params, resetForm)
            setCurrentPage(1);
            return;   
        }

        if (flag === 'Cel' && isNumber(e.target.value.slice(-1))){

            if (e.target.value.length > 8) {
                setInnerFieldValue(flag, e.target.value.slice(0, -1));
            }
            
            params[flag] = e.target.value.trim().slice(0, -1)
            fetchData(params, resetForm)
            setCurrentPage(1);
            return;   
        }

        params[flag] = e.target.value.trim();
        fetchData(params, resetForm);
        setCurrentPage(1);
    }

    const handleFocus = (e, flag, resetForm) => {

        if (!e.target.value || e.target.value.length < 4) {
            return;
        }

        setCurrentPage(1)

        const params = {
            "opcion": "ALUMNOS",
            [flag]: e.target.value.trim()
        }

        fetchData(params, resetForm)
    }

    const fetchDataNit = async (Nit, NombreDoc) => {
        try {
            const res = await Axios({
                method: 'GET',
                url: urlNit,
                headers,
                params: {
                    "Nit": Nit
                }
            })

            const { Nombre = '', Direccion = 'Ciudad', Error } = res.data.msg

            if (Error !== "1001") {
                setFieldValue('Nit', Nit)
                setFieldValue('NombreDoc', Nombre)
                setFieldValue('Direccion', Direccion)
            } else {
                throw new Error();
            }

        } catch (err) {
            console.log(err)

            setFieldValue('Nit', 'CF')
            setFieldValue('NombreDoc', '')
            setFieldValue('Direccion', 'Ciudad')
        }
    }

    const handleAlumno = async (alumno) => {
        const resNit = (alumno.Nit.toUpperCase() === 'C/F' || alumno.Nit === '' ? 'CF' : alumno.Nit)

        fetchDataNit(resNit, alumno.NombreDoc)

        setFieldValue('Alumno', alumno.Alumno)
        setFieldValue('Carnet', alumno.Carnet)
        setFieldValue('Cel', alumno.Celular)
        setFieldValue('Email', alumno.Email)
        setShowForm(false)
    }

    
    return (
        <WarningModal
            open={showForm ? true : false}
            width='w-auto lg:w-2/5'
            bgColor="bg-primarioMira"
            paddingTop='pt-11'
            opacity='bg-opacity-75'
            isDefault={false}
        >
            <div className="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
                <button
                    type="button"
                    className="rounded-md bg-secundarioMira text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2"
                    onClick={() => setShowForm(false)}
                >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-8 w-8" aria-hidden="true" />
                </button>
            </div>

            <Formik
                initialValues={{
                    Alumno: '',
                    Cel: '',
                    Email: '',
                    Nit: '',
                    Carnet: ''
                }}
            >
                {
                    ({setFieldValue: setInnerFieldValue, resetForm}) =>
                        <>
                            <Form>
                                <div className='grid grid-cols-2 gap-2'>
                                    {
                                        campos.map(({ name, type, position }) =>
                                            <div className={position}>
                                                <label className="block text-sm font-medium text-grisMira">
                                                    {name}
                                                </label>
                                                <Field
                                                    name={name}
                                                    onFocus={(e) => handleFocus(e, name, resetForm)}
                                                    onChange={(e) => handleChange(e, name, resetForm, setInnerFieldValue)}
                                                    type={type}
                                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                            </Form>
                        </>
                }
            </Formik>

            <ResultadosAlumnos
                alumnos={currentRecords}
                handleAlumno={handleAlumno}
            />
            <Pagination
                nPages={nPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={alumnos?.length}
                indexOfFirstRecord={indexOfFirstRecord}
                indexOfLastRecord={indexOfLastRecord}
            />

        </WarningModal>
    )
}

export default BusquedaAlumnosModal